import { Languages } from '../interfaces/common'

export const DEFAULT_LANGUAGE = Languages.RU
